import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const RootStyled = styled(Box)(() => ({
  padding: 18,
  '@media (min-width: 900px)': {
    padding: 24,
  },
  '@media (min-width: 1200px)': {
    padding: 55,
  },
  '@media (min-width: 1536px)': {
    padding: 90,
  },
}));

export const HeaderModalStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  '@media (max-width: 600px)': {
    '& svg': {
      fontSize: 32,
      marginLeft: -16,
    },
  },
  '& svg': {
    fontSize: 36,
    marginLeft: -16,
  },
}));

export const HeaderTitleStyled = styled(Typography)({
  margin: '18px 0 10px 0',
});

export const FeedbackContainer = styled(Box)({
  border: '1px solid #707070',
  borderRadius: '8px',
  padding: 28,
  marginTop: 18,
});

export const FormTitle = styled(Typography)({
  marginBottom: '20px',
});

export const MessageContainer = styled(Box)({
  border: '1px solid #B0B0B0',
  padding: 16,
  display: 'flex',
  '&: first-of-type': {
    borderRadius: '8px 8px 0 0',
    borderBottom: 'none',
  },
  '&: last-of-type': {
    borderRadius: '0 0 8px 8px',
  },
});

export const MessageTitle = styled(Typography)({
  fontWeight: 700,
  minWidth: '15%',
});

export const MessageTime = styled(Typography)({
  color: '#888888',
});

export const FieldContainer = styled(Box)({
  margin: '15px 0',
  width: '90%',
});
